// ===================================================================
// 🎨 ESTILOS GLOBAIS DO SISTEMA INGRESSAIF
// ===================================================================

export const styles = {
  // ✅ CONTAINERS PRINCIPAIS
  container: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    backgroundColor: '#F9FAFB',
    minHeight: '100vh'
  },
  
  mainContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  
  contentContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '24px',
    flex: 1
  },
  
  card: {
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    padding: '24px',
    marginBottom: '24px'
  },
  
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    paddingBottom: '16px',
    borderBottom: '1px solid #E5E7EB'
  },
  
  cardTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1F2937'
  },
  
  // ✅ BOTÕES
  button: {
    padding: '12px 24px',
    borderRadius: '8px',
    border: 'none',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px'
  },
  
  buttonPrimary: {
    backgroundColor: '#3B82F6',
    color: 'white'
  },
  
  buttonSecondary: {
    backgroundColor: '#E5E7EB',
    color: '#374151'
  },
  
  buttonSuccess: {
    backgroundColor: '#10B981',
    color: 'white'
  },
  
  buttonDanger: {
    backgroundColor: '#EF4444',
    color: 'white'
  },
  
  buttonWarning: {
    backgroundColor: '#F59E0B',
    color: 'white'
  },
  
  buttonSmall: {
    padding: '8px 16px',
    fontSize: '12px'
  },
  
  // ✅ TABELAS
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: 'white',
    borderRadius: '8px',
    overflow: 'visible',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    tableLayout: 'auto'
  },
  
  tableHeader: {
    backgroundColor: '#F9FAFB',
    borderBottom: '1px solid #E5E7EB'
  },
  
  tableHeaderCell: {
    padding: '16px',
    textAlign: 'left',
    fontWeight: '600',
    color: '#374151',
    fontSize: '14px',
    overflow: 'visible',
    whiteSpace: 'normal'
  },
  
  tableCell: {
    padding: '16px',
    borderBottom: '1px solid #F3F4F6',
    fontSize: '14px',
    color: '#6B7280',
    overflow: 'visible',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    overflowWrap: 'break-word'
  },
  
  tableRow: {
    transition: 'background-color 0.2s'
  },
  
  tableRowHover: {
    backgroundColor: '#F9FAFB'
  },

  // Tabela compacta (Processos, Cursos)
  tableCompactHeaderCell: {
    padding: '8px 10px',
    textAlign: 'left',
    fontWeight: '600',
    color: '#374151',
    fontSize: '12px',
    overflow: 'visible',
    whiteSpace: 'normal'
  },
  tableCompactCell: {
    padding: '8px 10px',
    borderBottom: '1px solid #F3F4F6',
    fontSize: '12px',
    color: '#374151',
    overflow: 'visible',
    whiteSpace: 'normal'
  },
  actionBtnIcon: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '4px 6px',
    gap: '2px',
    minWidth: '42px',
    fontSize: '12px'
  },

  // Badge em célula de tabela - evita corte/sobreposição de texto
  tableCellBadge: {
    whiteSpace: 'normal',
    textTransform: 'none',
    display: 'inline-block',
    maxWidth: '100%',
    lineHeight: 1.3,
    overflow: 'visible',
    overflowWrap: 'break-word',
    wordBreak: 'break-word'
  },
  
  // ✅ FORMULÁRIOS
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  
  formRow: {
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-end'
  },
  
  formGroup: {
    flex: 1
  },
  
  input: {
    width: '100%',
    padding: '12px 16px',
    border: '1px solid #D1D5DB',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.3s',
    boxSizing: 'border-box'
  },
  
  textarea: {
    width: '100%',
    padding: '12px 16px',
    border: '1px solid #D1D5DB',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.3s',
    boxSizing: 'border-box',
    resize: 'vertical',
    minHeight: '80px'
  },
  
  select: {
    width: '100%',
    padding: '12px 16px',
    border: '1px solid #D1D5DB',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.3s',
    boxSizing: 'border-box',
    backgroundColor: 'white'
  },
  
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '500',
    color: '#374151',
    marginBottom: '8px'
  },
  
  // ✅ LOADING
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
    minHeight: '200px'
  },
  
  spinner: {
    width: '48px',
    height: '48px',
    border: '4px solid #E5E7EB',
    borderTop: '4px solid #3B82F6',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginBottom: '16px'
  },
  
  loadingText: {
    color: '#6B7280',
    fontSize: '16px'
  },
  
  // ✅ AUTENTICAÇÃO
  authContainer: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #EBF8FF 0%, #E0E7FF 100%)',
    padding: '20px'
  },
  
  authBox: {
    background: 'white',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    width: '100%',
    maxWidth: '400px'
  },
  
  authTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#1F2937',
    textAlign: 'center',
    marginBottom: '8px'
  },
  
  authSubtitle: {
    fontSize: '14px',
    color: '#6B7280',
    textAlign: 'center',
    marginBottom: '32px'
  },
  
  // ✅ HEADER E NAVEGAÇÃO (dentro de wrapper sticky no App)
  header: {
    background: 'white'
  },
  
  nav: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '12px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  
  logoSection: {
    display: 'flex',
    alignItems: 'center'
  },
  
  logo: {
    width: '80px',
    height: '80px',
    backgroundColor: 'transparent',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '16px',
    fontWeight: 'bold',
    fontSize: '14px'
  },
  
  navTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#374151'
  },
  
  userSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  
  userName: {
    color: '#6B7280',
    fontSize: '14px'
  },
  
  userRole: {
    fontSize: '12px',
    backgroundColor: '#EFF6FF',
    color: '#1E40AF',
    padding: '4px 8px',
    borderRadius: '12px',
    fontWeight: '500'
  },
  
  // ✅ BARRA DE NAVEGAÇÃO (permanece visível ao rolar - wrapper no App)
  navBar: {
    background: 'white',
    borderBottom: '1px solid #E5E7EB'
  },
  
  navContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '8px 24px'
  },
  
  navLinks: {
    display: 'flex',
    gap: '24px'
  },
  
  navLink: {
    padding: '8px 16px',
    borderRadius: '8px',
    color: '#6B7280',
    cursor: 'pointer',
    transition: 'all 0.3s',
    fontSize: '14px',
    fontWeight: '500'
  },
  
  navLinkActive: {
    padding: '8px 16px',
    borderRadius: '8px',
    backgroundColor: '#3B82F6',
    color: 'white',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600'
  },
  
  // ✅ STATUS BADGES
  statusBadge: {
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'uppercase'
  },
  
  statusPending: {
    backgroundColor: '#FEF3C7',
    color: '#92400E'
  },
  
  statusApproved: {
    backgroundColor: '#D1FAE5',
    color: '#065F46'
  },
  
  statusRejected: {
    backgroundColor: '#FEE2E2',
    color: '#991B1B'
  },
  
  statusPaid: {
    backgroundColor: '#D1FAE5',
    color: '#065F46'
  },
  
  statusExempted: {
    backgroundColor: '#E0E7FF',
    color: '#3730A3'
  },
  
  // ✅ MODAL
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px'
  },
  
  modalContent: {
    background: 'white',
    borderRadius: '12px',
    padding: '24px',
    maxWidth: '600px',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto'
  },
  
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    paddingBottom: '16px',
    borderBottom: '1px solid #E5E7EB'
  },
  
  modalTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1F2937'
  },
  
  modalClose: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#6B7280',
    padding: '4px'
  },
  
  // ✅ ALERTAS
  alert: {
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  
  alertSuccess: {
    backgroundColor: '#D1FAE5',
    color: '#065F46',
    border: '1px solid #A7F3D0'
  },
  
  alertError: {
    backgroundColor: '#FEE2E2',
    color: '#991B1B',
    border: '1px solid #FCA5A5'
  },
  
  alertWarning: {
    backgroundColor: '#FEF3C7',
    color: '#92400E',
    border: '1px solid #FCD34D'
  },
  
  alertInfo: {
    backgroundColor: '#DBEAFE',
    color: '#1E40AF',
    border: '1px solid #93C5FD'
  },
  
  // ✅ UTILITÁRIOS
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  
  flexBetween: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  
  textCenter: {
    textAlign: 'center'
  },
  
  textRight: {
    textAlign: 'right'
  },
  
  mb16: {
    marginBottom: '16px'
  },
  
  mb24: {
    marginBottom: '24px'
  },
  
  mt16: {
    marginTop: '16px'
  },
  
  mt24: {
    marginTop: '24px'
  },
  
  gap16: {
    gap: '16px'
  },
  
  gap24: {
    gap: '24px'
  },

  // ✅ ELEMENTOS DE ISENÇÃO
  fileUploadArea: {
    border: '2px dashed #D1D5DB',
    borderRadius: '8px',
    padding: '24px',
    textAlign: 'center',
    backgroundColor: '#F9FAFB',
    transition: 'border-color 0.3s, background-color 0.3s',
    cursor: 'pointer'
  },

  fileUploadAreaHover: {
    borderColor: '#3B82F6',
    backgroundColor: '#F0F9FF'
  },

  fileInput: {
    display: 'none'
  },

  fileUploadText: {
    margin: '0 0 8px 0',
    fontSize: '16px',
    color: '#374151',
    fontWeight: '500'
  },

  fileUploadInfo: {
    margin: '0',
    fontSize: '12px',
    color: '#6B7280'
  },

  documentsList: {
    marginTop: '16px',
    padding: '16px',
    backgroundColor: '#F9FAFB',
    borderRadius: '8px',
    border: '1px solid #E5E7EB'
  },

  documentItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 12px',
    backgroundColor: 'white',
    borderRadius: '6px',
    marginBottom: '8px',
    border: '1px solid #E5E7EB'
  },

  documentName: {
    fontSize: '14px',
    color: '#374151',
    flex: 1
  },

  removeDocumentButton: {
    background: '#EF4444',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  removeDocumentButtonHover: {
    backgroundColor: '#DC2626'
  },

  // ✅ ESTILOS PARA CAMPOS DE NOTA (SEM SPINNER)
  gradeInput: {
    width: '100%',
    padding: '8px',
    border: '1px solid #D1D5DB',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 'bold',
    textAlign: 'center',
    outline: 'none',
    transition: 'border-color 0.3s',
    boxSizing: 'border-box',
    WebkitAppearance: 'none',
    MozAppearance: 'textfield',
    marginBottom: 0
  },

  // ✅ UTILITÁRIOS ADICIONAIS (admin/analyst)
  flex: { display: 'flex', alignItems: 'center' },
  flexWrap: { flexWrap: 'wrap' },
  gap2: { gap: '8px' },
  gap4: { gap: '16px' },
  mb4: { marginBottom: '16px' },
  mb6: { marginBottom: '24px' },
  py8: { padding: '32px 0' },
  th: { padding: '16px', textAlign: 'left', fontWeight: '600', color: '#374151', fontSize: '14px', backgroundColor: '#F9FAFB', borderBottom: '1px solid #E5E7EB' },
  td: { padding: '16px', borderBottom: '1px solid #F3F4F6', fontSize: '14px', color: '#6B7280' },
  tr: { transition: 'background-color 0.2s' },
  tableContainer: { overflowX: 'auto' },
  tableScrollContainer: { maxHeight: '65vh', overflowY: 'auto', overflowX: 'auto' },
  tableWrapper: { overflowX: 'auto' },
  emptyState: { textAlign: 'center', padding: '48px 24px', color: '#6B7280', fontSize: '16px' },
  grid: { display: 'grid' },
  gridCols3: { gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' },
  buttonInfo: { backgroundColor: '#0EA5E9', color: 'white' },
  pageHeader: { marginBottom: '24px' },
  pageTitle: { fontSize: '24px', fontWeight: 'bold', color: '#111827', margin: '0 0 8px 0' },
  pageSubtitle: { fontSize: '16px', color: '#6B7280', margin: 0 }
}; 